import apiSlice from '../api/slice'
import { TAGS } from '../../constants/tags'

const viewsSlice = apiSlice.injectEndpoints({
  name: 'views',
  endpoints: (builder) => ({
    getViews: builder.query({
      query: () => ({ url: `/v1/admin/views`, method: 'GET' }),
      transformResponse: (response) => response.data,
      providesTags: [TAGS.VIEWS],
    }),
    addView: builder.mutation({
      query: (gridState) => ({
        url: `/v1/admin/views`,
        method: 'POST',
        body: gridState,
      }),
      invalidatesTags: [TAGS.VIEWS],
    }),
    deleteView: builder.mutation({
      query: (viewId) => ({
        url: `/v1/admin/views/${viewId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [TAGS.VIEWS],
    }),
  }),
})

export const { useGetViewsQuery, useAddViewMutation, useDeleteViewMutation } = viewsSlice
